import _extends from "@babel/runtime/helpers/extends";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { DropdownCustom } from "./components/DropdownCustom";
import DropDownNative from "./components/DropdownNative";
import { getMobileOS } from "../../utils/detect-mobile";
export var DropDownStateless = getMobileOS() ? DropDownNative : DropdownCustom;
var DropDown = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DropDown, _React$PureComponent);
  var _super = _createSuper(DropDown);
  function DropDown(props) {
    var _this;
    _classCallCheck(this, DropDown);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (_ref) {
      var value = _ref.value;
      if (value !== _this.props.value) {
        _this.setState({
          value: value
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getChildrenProps", function () {
      return _objectSpread(_objectSpread(_objectSpread({}, _this.props), _this.state), {}, {
        onChange: _this.handleChange
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getValue", function () {
      return _this.state.value;
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
      return _this.setState({
        value: value
      }, function () {
        return _this.props.onChange(value);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      return _this.dropdown.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/React.createElement(DropDownStateless, _extends({
        ref: function ref(e) {
          _this.dropdown = e;
        }
      }, _this.getChildrenProps()));
    });
    _this.state = {
      value: props.value || null
    };
    return _this;
  }
  return _createClass(DropDown);
}(React.PureComponent);
_defineProperty(DropDown, "defaultProps", _objectSpread(_objectSpread({}, DropDownStateless.defaultProps), {}, {
  value: null,
  onChange: function onChange() {
    return undefined;
  }
}));
export { DropDown as default };
DropDown.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread({}, DropDownStateless.propTypes), {}, {
  value: PropTypes.any,
  onChange: PropTypes.func
}) : {};